import { message } from 'antd';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getCurrentUser, postLogin } from 'src/services/userService';
import HttpClient from '../../services/http';
import { setToken, setUser } from './actions';
import { GET_USER, LOGIN } from './types';

function* setLoginSaga({ payload }: any): any {
  try {
    const hide = message.loading('Logining in...');
    const res: any = yield call(postLogin, payload);
    if (res.status === 201) {
      localStorage.setItem('token', res.data.accessToken);
      localStorage.setItem('accessTokenExpiresAt', res.data.accessTokenExpiresAt);
      localStorage.setItem('userId', res.data.user.id);
      localStorage.setItem('userRole', 'member');
      yield put(setToken(res.data.accessToken));
    } else {
      message.error('username or/and password is not correct');
    }
    hide();
  } catch (e: any) {
    return message.error(e);
  }
}
function* setUserSaga(): any {
  try {
    const hide = message.loading('...');
    const res = yield call(getCurrentUser);

    if (HttpClient.isOkStatus(res.status)) {
      yield put(setUser(res.data));
    }

    hide();
  } catch {
    return message.error('user not found');
  }
}
export function* watchUser(): any {
  yield takeLatest(LOGIN, setLoginSaga);
  yield takeLatest(GET_USER, setUserSaga);
}
